import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import "./PricingPage.css";
import "./rangSliderVert.css";
import { useAuth } from "../AuthContext";
import instance, { currencyReturn, apiEncryptRequest, decryptData } from "../Api";
import Loader from "./common/Loader";

const PricingPage = (props) => {
  const { isMobile } = props;
  const { appCurrency } = useAuth();

  const Pages        = ["Custom Configure", "CDN"];
  const innerButtons = ["Standard", "CPU Proactive", "RAM Proactive"];
  const dataTransfers = ["GB", "TB"];

  // Slider values — Custom Configure
  const [customCPU,  setCustomCPU]  = useState(0);
  const [customRAM,  setCustomRAM]  = useState(0);
  const [customDISK, setCustomDISK] = useState(0);
  const [customDATAT,setCustomDATAT]= useState(0);

  // Summary badges
  const [selectedCPU, setSelectedCPU] = useState(0);
  const [selectedRAM, setSelectedRAM] = useState(0);
  const [selectedSSD, setSelectedSSD] = useState(0);
  const [selectedDT,  setSelectedDT]  = useState(0);

  const [configType,    setConfigType]    = useState(1);
  const [activeButton,  setActiveButton]  = useState("Standard");
  const [diskType,      setDisktype]      = useState("ssd");
  const [activePage,    setActivePage]    = useState("Custom Configure");
  const [selectedIdx,   setSelectedIdx]   = useState(null);
  const [finalAmount,   setFinalAmount]   = useState("0");

  // Rate data from API
  const [stdCusHDD, setStdCusHDD] = useState({});
  const [stdCusSSD, setStdCusSSD] = useState({});
  const [stdCusNVM, setStdCusNVM] = useState({});
  const [cpuCusHDD, setCpuCusHDD] = useState({});
  const [cpuCusSSD, setCpuCusSSD] = useState({});
  const [cpuCusNVM, setCpuCusNVM] = useState({});
  const [ramCusHDD, setRamCusHDD] = useState({});
  const [ramCusSSD, setRamCusSSD] = useState({});
  const [ramCusNVM, setRamCusNVM] = useState({});
  const [custConfigData, setCustConfigData] = useState({});
  const [loading, setLoading] = useState(true);

  // CDN slider
  const [cdnGBPrice, setGBPrice]           = useState("");
  const [cdnTBPrice, setTBPrice]           = useState("");
  const [selectedTransfers, setSelectedTransfers] = useState("GB");
  const [value, setValue]                  = useState(0);

  useEffect(() => {
    CreateVm();
    CdnPrice();
  }, []);

  // ── API calls ──────────────────────────────────────────────────────────────
  const CreateVm = async () => {
    setLoading(true);
    try {
      const enc  = await apiEncryptRequest();
      const res  = await instance.post("/create-vm", enc);
      const data = await decryptData(res.data);

      setStdCusHDD(data.ratedata1);  setStdCusSSD(data.ratedata5);  setStdCusNVM(data.ratedata6);
      setCpuCusHDD(data.ratedata3);  setCpuCusSSD(data.ratedata7);  setCpuCusNVM(data.ratedata8);
      setRamCusHDD(data.ratedata4);  setRamCusSSD(data.ratedata9);  setRamCusNVM(data.ratedata10);
      setCustConfigData(data.custom_configure);
    } catch (e) { /* silent */ }
    setLoading(false);
  };

  const CdnPrice = async () => {
    setLoading(true);
    try {
      const enc  = await apiEncryptRequest();
      const res  = await instance.post("/cdn_price", enc);
      const data = await decryptData(res.data);
      if (data.status) { setGBPrice(data.cdn_price.gb_price); setTBPrice(data.cdn_price.price); }
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  // ── Price calculation — used in both mobile and web rendering ────────────
  // Applies discount: subtotal - (discount% * subtotal) / 100
  const calcSubtotal = (rates, diskKey) => {
    const diskRate = diskKey === "hdd" ? rates.hdd_rate : diskKey === "ssd" ? rates.ssd_price : rates.nvme_price;
    const sub = customCPU * rates.cpu_rate + customRAM * rates.ram_rate + customDISK * diskRate + customDATAT * 1;
    return sub - (rates.custom_discount * sub) / 100;
  };

  const totalPrice = () => {
    const byConfig = configType === 1
      ? { hdd: stdCusHDD, ssd: stdCusSSD, nvme: stdCusNVM }
      : configType === 2
      ? { hdd: cpuCusHDD, ssd: cpuCusSSD, nvme: cpuCusNVM }
      : { hdd: ramCusHDD, ssd: ramCusSSD, nvme: ramCusNVM };
    const rates = diskType === "ssd" ? byConfig.ssd : diskType === "nvme" ? byConfig.nvme : byConfig.hdd;
    return calcSubtotal(rates, diskType);
  };

  const cdnPrice = () =>
    (selectedTransfers === "GB" ? value * cdnGBPrice : value * cdnTBPrice) * 1024;

  const priceSym = localStorage.getItem("PrefCurrency");

  const PriceDisplay = () =>
    activePage === "Custom Configure"
      ? currencyReturn({ price: totalPrice(), symbol: priceSym, rates: appCurrency })
      : currencyReturn({ price: cdnPrice(), symbol: priceSym, rates: appCurrency });

  // ── Disk type selector — same in mobile + web ─────────────────────────────
  const DiskSelect = () => (
    <select name="plan_time" value={diskType}
      style={{ borderRadius:"30px", border:"2px solid #e97730", color:"#144e7b", fontWeight:"700", backgroundColor:"transparent" }}
      onChange={(e) => { setDisktype(e.target.value); setCustomDISK(0); }}>
      <option value="hdd">HDD Disk</option>
      <option value="ssd">SSD Disk</option>
      <option value="nvme">NVMe Disk</option>
    </select>
  );

  // ── GB/TB radio selector — same in mobile + web ───────────────────────────
  const TransferSelector = ({ style }) => (
    <div className="multi-select-container" style={style}>
      {dataTransfers.map((opt) => (
        <div key={opt} className="custom-radio">
          <input type="checkbox" id={opt} name={opt} checked={selectedTransfers === opt} onChange={() => { if (selectedTransfers !== opt) setSelectedTransfers(opt); }} />
          <label htmlFor={opt} className="radio-label">{opt}</label>
        </div>
      ))}
    </div>
  );

  // ── Page tab reset helper ─────────────────────────────────────────────────
  const switchPage = (item) => { setActivePage(item); setSelectedIdx(null); setFinalAmount("0"); };

  // ── RENDER ────────────────────────────────────────────────────────────────
  return (
    <div style={{ height:"100vh" }}>
      {isMobile ? (
        /* ── MOBILE ── */
        <>
          <div className="heading-dotted-pricing">Pricing <span /></div>
          <div style={{ marginTop:"6rem" }}>

            {/* Summary badges */}
            <div className="buttons-container">
              {[`${selectedCPU} vCPU`, `${selectedRAM} GB RAM`, `${selectedSSD} GB SSD Disk`, `${selectedDT} TB Bandwidth`].map((label) => (
                <Button key={label} className="top-buttons-creact-machine" style={{ fontSize:"14px" }}>{label}</Button>
              ))}
            </div>

            {/* Create Machine button */}
            <div className="log-in" style={{ marginLeft:"-40px" }}>
              <a href="/signUp" className="media-link">
                <div className="media-banner" style={{ width:"160px", height:"65px", marginLeft:"16rem" }}>
                  <img className="normal-banner" src="/images/signup-btn-bg.png" alt="" />
                  <img className="hover-img-banner" src="/images/search-btn-hover.png" alt="/images/search-btn-hover.png" />
                  <span className="login-text" style={{ fontSize:"20px", color:"#07528B", marginTop:"0px" }}>Create Machine</span>
                </div>
              </a>
            </div>

            {/* Page tabs */}
            {Pages.map((item) => (
              <div key={item}
                className={activePage === item ? "active-mobile-vm" : "non-active-mobile-vm"}
                onClick={() => switchPage(item)}
                style={item === "Custom Configure"
                  ? { paddingTop: activePage === "Custom Configure" ? "24px" : "20px", marginTop:"-10px" }
                  : { paddingTop:"25px", marginLeft:"5rem", marginTop:"-10px" }}>
                {item}
              </div>
            ))}

            {/* Price display */}
            <div className="pricing-right" style={{ fontSize:"20px" }}>
              <PriceDisplay />
            </div>

            <div className="tab-box" style={{ minHeight: activePage === "Custom Configure" ? "40rem" : "100px" }}>
              {activePage === "Custom Configure" ? (
                <>
                  {/* Inner config buttons */}
                  <div className="buttons-container" style={{ padding:"15px" }}>
                    {innerButtons.map((title, idx) => (
                      <Button key={idx} style={{ background: activeButton === title ? "#f47c20" : "#035189", border:"none", fontSize:"14px", padding:"5px 15px", color:"#fff", fontWeight:"600", borderRadius:"5px", marginBottom:"10px" }}
                        onClick={() => setActiveButton(title)}>{title}</Button>
                    ))}
                  </div>

                  {/* Column headers */}
                  <div className="title-box">
                    {[["CPU","25%"], ["RAM","25%"]].map(([label, w]) => (
                      <h6 key={label} style={{ width:w, textAlign:"center", fontSize:"16px", fontWeight:"700", marginTop:"10px" }}>{label}</h6>
                    ))}
                    <DiskSelect />
                    <h6 style={{ width:"25%", textAlign:"center", fontSize:"16px", fontWeight:"700" }}>BAND<br/>WIDTH</h6>
                  </div>

                  {/* Vertical range sliders */}
                  <div style={{ marginTop:"12rem", position:"absolute" }}>
                    {/* CPU */}
                    <div className="range-slider-vrt">
                      <div className="tooltip-horz-vrt" style={{ left:"1.9rem", top:"-13rem", position:"absolute" }}>{customCPU}</div>
                      <input type="range" min="0" max="32" value={customCPU} className="custom-rangeInput-vrt"
                        style={{ left:"-6rem", position:"absolute", background:`linear-gradient(to right, #e97730 ${(customCPU*100)/32}%, #ddd ${(customCPU*100)/32}%)` }}
                        onChange={(e) => { setCustomCPU(e.target.value); setSelectedCPU(e.target.value); }} />
                    </div>
                    {/* RAM */}
                    <div className="range-slider-vrt">
                      <div className="tooltip-horz-vrt" style={{ left:"6.9rem", top:"-13rem", position:"absolute" }}>{customRAM}</div>
                      <input type="range" min="0" max="510" value={customRAM} className="custom-rangeInput-vrt"
                        style={{ left:"-1rem", position:"absolute", background:`linear-gradient(to right, #e97730 ${(customRAM*100)/510}%, #ddd ${(customRAM*100)/510}%)` }}
                        onChange={(e) => { setCustomRAM(e.target.value); setSelectedRAM(e.target.value); }} />
                    </div>
                    {/* DISK */}
                    <div className="range-slider-vrt">
                      <div className="tooltip-horz-vrt" style={{ left:"12rem", top:"-13rem", position:"absolute" }}>{customDISK}</div>
                      <input type="range" min="0" max={diskType === "hdd" ? "10000" : "5000"} value={customDISK} className="custom-rangeInput-vrt"
                        style={{ left:"4.2rem", position:"absolute", background:`linear-gradient(to right, #e97730 ${(customDISK*100)/(diskType==="hdd"?10000:5000)}%, #ddd ${(customDISK*100)/(diskType==="hdd"?10000:5000)}%)` }}
                        onChange={(e) => { setCustomDISK(e.target.value); setSelectedSSD(e.target.value); }} />
                    </div>
                    {/* BANDWIDTH */}
                    <div className="range-slider-vrt">
                      <div className="tooltip-horz-vrt" style={{ left:"17.9rem", top:"-13rem", position:"absolute" }}>{customDATAT}</div>
                      <input type="range" min="0" max="32" value={customDATAT} className="custom-rangeInput-vrt"
                        style={{ left:"10rem", position:"absolute", background:`linear-gradient(to right, #e97730 ${(customDATAT*100)/32}%, #ddd ${(customDATAT*100)/32}%)` }}
                        onChange={(e) => { setCustomDATAT(e.target.value); setSelectedDT(e.target.value); }} />
                    </div>
                  </div>
                </>
              ) : (
                /* CDN tab */
                <>
                  <div className="title-box">
                    <h6 style={{ textAlign:"center", fontSize:"16px", fontWeight:"700", marginTop:"15px" }}>CDN BANDWIDTH</h6>
                  </div>
                  <TransferSelector style={{ marginLeft:"5px" }} />
                  <div className="range-slider-vrt" style={{ marginLeft:"50px", marginTop:"-30px" }}>
                    <div className="tooltip-horz-vrt" style={{ left:"9.2rem", top:"-20px", position:"absolute" }}>
                      {value} {selectedTransfers === "GB" ? "GB" : "TB"}
                    </div>
                    <input type="range" min="0" max="100" value={value} className="custom-rangeInput-vrt"
                      style={{ left:"1.3rem", top:"200px", position:"absolute", background:`linear-gradient(to right, #e97730 ${value}%, #ddd ${value}%)` }}
                      onChange={(e) => setValue(e.target.value)} />
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        /* ── WEB ── */
        <>
          <div className="col-md-1" />
          <div className="see-width col-md-11" style={{ marginTop:"5rem", marginLeft:"11rem", width:"90%" }}>
            <div className="heading-dotted-pricing">Pricing <span /></div>

            {/* Summary badges */}
            <div className="buttons-container" style={{ marginTop:"2rem" }}>
              {[`${selectedCPU} vCPU`, `${selectedRAM} GB RAM`, `${selectedSSD} GB SSD Disk`, `${selectedDT} TB Bandwidth`].map((label) => (
                <Button key={label} className="top-buttons-creact-machine">{label}</Button>
              ))}
            </div>

            {/* Create Machine button */}
            <div className="log-in" style={{ marginTop:"-4.5rem", marginLeft:"70%" }}>
              <a href="/signUp" className="media-link">
                <div className="media-banner" style={{ width:"160px", height:"65px", marginTop:"10px", marginLeft:"16rem" }}>
                  <img className="normal-banner" src="/images/signup-btn-bg.png" alt="" />
                  <img className="hover-img-banner" src="/images/search-btn-hover.png" alt="/images/search-btn-hover.png" />
                  <span className="login-text" style={{ fontSize:"20px", color:"#07528B", marginTop:"0px" }}>Create Machine</span>
                </div>
              </a>
            </div>

            <div className="tab-box" style={{ minHeight: activePage === "Custom Configure" ? "40rem" : "100px", marginTop:"50px" }}>
              {/* Page tabs */}
              {Pages.map((item) => (
                <div key={item}
                  className={activePage === item ? "active-web-vm" : "non-active-web-vm"}
                  onClick={() => switchPage(item)}
                  style={item === "Custom Configure"
                    ? { paddingTop: activePage === "Custom Configure" ? "24px" : "20px" }
                    : { paddingTop:"40px" }}>
                  {item}
                </div>
              ))}

              {/* Price display */}
              <div className="pricing-right">
                <PriceDisplay />
              </div>

              {activePage === "Custom Configure" ? (
                <>
                  {/* Config type buttons */}
                  <div className="buttons-container" style={{ padding:"15px", marginTop:"-14rem" }}>
                    {innerButtons.map((title, idx) => (
                      <Button key={idx} style={{ background: activeButton === title ? "#f47c20" : "#035189", border:"none", fontSize:"22px", padding:"5px 15px", color:"#fff", fontWeight:"600", borderRadius:"5px", marginBottom:"10px" }}
                        onClick={() => { setActiveButton(title); setConfigType(idx + 1); }}>{title}</Button>
                    ))}
                  </div>

                  {/* Column labels */}
                  <div className="title-box-pricing" style={{ backgroundImage:`url(/images/frontend/price/server-img.png)`, backgroundPosition:"center" }}>
                    <h6 style={{ textAlign:"center", fontSize:"30px", fontWeight:"800", marginTop:"45px" }}>vCPU</h6>
                    <h6 style={{ textAlign:"center", fontSize:"30px", fontWeight:"800", marginTop:"85px" }}>RAM</h6>
                    <div className="ssd price" data-value="40" style={{ textAlign:"center", fontWeight:"600", fontSize:"24px", position:"relative", marginTop:"80px" }}>
                      <DiskSelect />
                    </div>
                    <h6 style={{ textAlign:"center", fontSize:"30px", fontWeight:"800", marginTop:"60px" }}>BANDWIDTH</h6>
                  </div>

                  {/* Horizontal range sliders */}
                  <div style={{ marginLeft:"19rem", position:"relative", marginTop:"-30rem", flexWrap:"wrap", justifyContent:"space-around" }}>
                    {/* CPU */}
                    <div className="range-slider">
                      <div className="tooltip-horz" style={{ left:`${(customCPU*100)/32}%` }}>{customCPU} Core</div>
                      <input type="range" min="0" max="32" value={customCPU} className="custom-rangeInput"
                        style={{ background:`linear-gradient(to right, #e97730 ${(customCPU*100)/32}%, #ddd ${(customCPU*100)/32}%)` }}
                        onChange={(e) => { setCustomCPU(e.target.value); setSelectedCPU(e.target.value); }} />
                    </div>
                    {/* RAM */}
                    <div className="range-slider" style={{ marginTop:"70px" }}>
                      <div className="tooltip-horz" style={{ left:`${(customRAM*100)/510}%` }}>{customRAM} GB</div>
                      <input type="range" min="0" max="510" value={customRAM} className="custom-rangeInput"
                        style={{ background:`linear-gradient(to right, #e97730 ${(customRAM*100)/510}%, #ddd ${(customRAM*100)/510}%)` }}
                        onChange={(e) => { setCustomRAM(e.target.value); setSelectedRAM(e.target.value); }} />
                    </div>
                    {/* DISK */}
                    <div className="range-slider" style={{ marginTop:"60px" }}>
                      <div className="tooltip-horz" style={{ left:`${(customDISK*100)/(diskType==="hdd"?10000:5000)}%` }}>{customDISK} GB</div>
                      <input type="range" min="0" max={diskType === "hdd" ? "10000" : "5000"} value={customDISK} className="custom-rangeInput"
                        style={{ background:`linear-gradient(to right, #e97730 ${(customDISK*100)/(diskType==="hdd"?10000:5000)}%, #ddd ${(customDISK*100)/(diskType==="hdd"?10000:5000)}%)` }}
                        onChange={(e) => { setCustomDISK(e.target.value); setSelectedSSD(e.target.value); }} />
                    </div>
                    {/* BANDWIDTH */}
                    <div className="range-slider" style={{ marginTop:"45px" }}>
                      <div className="tooltip-horz" style={{ left:`${(customDATAT*100)/32}%` }}>{customDATAT} TB</div>
                      <input type="range" min="0" max="32" value={customDATAT} className="custom-rangeInput"
                        style={{ background:`linear-gradient(to right, #e97730 ${(customDATAT*100)/32}%, #ddd ${(customDATAT*100)/32}%)` }}
                        onChange={(e) => { setCustomDATAT(e.target.value); setSelectedDT(e.target.value); }} />
                    </div>
                  </div>
                </>
              ) : (
                /* CDN tab */
                <>
                  <div className="title-box-cdn-pricing" style={{ backgroundImage:`url(/images/frontend/price/server-img.png)`, backgroundPosition:"center", height:"30px", marginTop:"-8rem" }}>
                    <h6 style={{ textAlign:"center", fontSize:"25px", fontWeight:"800", marginTop:"30px" }}>CDN<p>Bandwidth</p></h6>
                    <TransferSelector style={{ marginLeft:"13rem", marginTop:"-11rem" }} />
                  </div>
                  <div style={{ width:"85%", height:"200px", marginLeft:"15rem", marginTop:"-8rem" }}>
                    <div style={{ marginLeft:"-15px", marginRight:"-10px", marginBottom:"-10px" }}>
                      <div className="range-slider">
                        <div className="tooltip-horz" style={{ left:`${value}%` }}>
                          {value} {selectedTransfers === "GB" ? "GB" : "TB"}
                        </div>
                        <input type="range" min="0" max="100" value={value} className="custom-rangeInput"
                          style={{ background:`linear-gradient(to right, #e97730 ${value}%, #ddd ${value}%)` }}
                          onChange={(e) => setValue(e.target.value)} />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {loading && (
        <div className="loading-overlay" style={{ zIndex:"9999999999999999" }}>
          <Loader isLoading={loading} />
        </div>
      )}
    </div>
  );
};

export default PricingPage;